import CodiciComuniCamera from '@/data/mapping-camera-comuni7917.json';
import CodiciComuniMultiCollegioCamera from '@/data/mapping-camera-SoloComuniFrazionati.json';
import CodiciComuniSenato from '@/data/mapping-senato-comuni7909.json';
import CodiciComuniMultiCollegioSenato from '@/data/mapping-senato-SoloComuniFrazionati.json';
import CodiciComuni from '@/data/Raccordo_Comuni_seas_istatshape.json';
import { ResultCodes, StructureType } from './model';

export const getCodComune = (
  codReg: string | undefined,
  codProv: string | undefined,
  codComune: string | undefined
) => {
  // remove initial 0 from SEAS
  if (codReg?.indexOf('0') === 0) {
    codReg = codReg.substring(1);
  }
  // remove initial 0 from SEAS
  if (codProv?.indexOf('0') === 0) {
    codProv = codProv.substring(1);
  }
  // remove initial 0 from SEAS
  if (codComune?.indexOf('0') === 0) {
    codComune = codComune.substring(1);
  }

  return (
    CodiciComuni.find(
      c =>
        c.cod_regione === codReg &&
        c.cod_provincia === codProv &&
        c.cod_comune === codComune
    )?.PRO_COM || null
  );
};

export const getCodComuneFraz = (
  type: StructureType,
  codReg: string | undefined,
  codProv: string | undefined,
  codComune: string | undefined,
  cod_cl_uni: string | undefined
) => {
  // remove initial 0 from SEAS
  if (codReg?.indexOf('0') === 0) {
    codReg = codReg.substring(1);
  }
  // remove initial 0 from SEAS
  if (codProv?.indexOf('0') === 0) {
    codProv = codProv.substring(1);
  }
  // remove initial 0 from SEAS
  if (codComune?.indexOf('0') === 0) {
    codComune = codComune.substring(1);
  }

  if (type === StructureType.CAMERA) {
    let res: any = CodiciComuniCamera.find(
      (c: any) =>
        c.cod_regione === codReg &&
        c.cod_provincia === codProv &&
        c.cod_comune === codComune &&
        c.cod_cl_uni === cod_cl_uni
    );
    if (type == StructureType.CAMERA && res?.PRO_COM_CU !== undefined) {
      return res.PRO_COM_CU;
    } else if (res?.PRO_COM !== undefined) {
      return res.PRO_COM;
    }
  } else if (type === StructureType.SENATE) {
    let res: any = CodiciComuniSenato.find(
      (c: any) =>
        c.cod_regione === codReg &&
        c.cod_provincia === codProv &&
        c.cod_comune === codComune &&
        c.cod_cl_uni === cod_cl_uni
    );
    if (res?.PRO_COM_SU !== undefined) {
      return res.PRO_COM_SU;
    } else if (res?.PRO_COM !== undefined) {
      return res.PRO_COM;
    }
  }
  return null;
};

export const getFileNameComune = (type: StructureType, codes: ResultCodes) => {
  let typeCode = type === StructureType.CAMERA ? '02' : '03';
  let codCircReg = type === StructureType.CAMERA ? codes.codCirc : codes.codReg;

  let codPluri = codes.codClPlu?.padStart(3, '0'); // default
  if (
    (type === StructureType.CAMERA && codes.codCirc === '27') ||
    (type === StructureType.SENATE &&
      (codes.codCirc === '2' || codes.codCirc === '21'))
  ) {
    // Valle d'Aosta or Trentino
    codPluri = '';
  }

  return (
    typeCode +
    codCircReg?.padStart(2, '0') +
    codPluri +
    codes.codClUni?.padStart(4, '0') +
    codes.codProv?.padStart(3, '0') +
    codes.codCom?.padStart(4, '0')
  );
};

export const getAllClUniComune = (
  type: StructureType,
  reg: string | undefined,
  prov: string | undefined,
  comune: string | undefined
) => {
  let codici =
    type === StructureType.CAMERA
      ? CodiciComuniMultiCollegioCamera
      : CodiciComuniMultiCollegioSenato;
  return codici
    .filter(
      c =>
        c.cod_regione === reg &&
        c.cod_provincia === prov &&
        c.cod_comune === comune
    )
    .map(c => c.cod_cl_uni);
};

export const isComuneMultiCollegio = (
  type: StructureType,
  pro_com: string | undefined
) => {
  let codici =
    type === StructureType.CAMERA
      ? CodiciComuniMultiCollegioCamera
      : CodiciComuniMultiCollegioSenato;
  return codici.filter(c => c.PRO_COM === pro_com).length > 0;
};
